import { render, staticRenderFns } from "./CreateBid.vue?vue&type=template&id=139fbea4&"
import script from "./CreateBid.vue?vue&type=script&lang=js&"
export * from "./CreateBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports